import React, { Component } from "react";
import classNames from "classnames";
import { withRouter } from "react-router-dom";
import { connect } from "react-redux";
import "./HomeCollections.css";

class HomeCollections extends Component {
  constructor() {
    super();

    this.state = {
      translatePosition: 0,
      slideGallery: false,
      fadeInContent: false
    };

    this.handleScroll = this.handleScroll.bind(this);
    this.handleKeyDown = this.handleKeyDown.bind(this);
  }

  componentDidMount() {
    document.addEventListener("scroll", this.handleScroll);
    document.addEventListener("keydown", this.handleKeyDown);
  }

  componentWillUnmount() {
    document.removeEventListener("scroll", this.handleScroll);
    document.removeEventListener("keydown", this.handleKeyDown);
  }

  handleKeyDown(e) {
    const { data } = this.props;
    const { translatePosition } = this.state;
    const LEFT_ARROW = e.keyCode === 37;
    const RIGHT_ARROW = e.keyCode === 39;
    const isOnStart = translatePosition === 0;
    const isOnEnd = translatePosition === data.length - 1;
    if (LEFT_ARROW && !isOnStart) {
      this.changeCollection("prev");
    } else if (RIGHT_ARROW && !isOnEnd) {
      this.changeCollection("next");
    }
  }

  handleScroll() {
    const elem = document.querySelector(".HomeCollections-Gallery");
    if (elem.getBoundingClientRect().top < 500) {
      this.setState({
        slideGallery: true,
        fadeInContent: true
      });
      document.removeEventListener("scroll", this.handleScroll);
    }
  }

  changeCollection(direction) {
    const { translatePosition } = this.state;
    if (direction === "prev") {
      this.setState({
        translatePosition: translatePosition - 1
      });
    } else if (direction === "next") {
      this.setState({
        translatePosition: translatePosition + 1
      });
    }
  }

  handleTouchStart(event) {
    this.x = event.touches[0].clientX;
    this.y = event.touches[0].clientY;
  }

  handleTouchMove(event) {
    this.xM = event.changedTouches[0].clientX;
    this.yM = event.changedTouches[0].clientY;
    const xDiff = this.xM - this.x;
    const yDiff = this.yM - this.y;
    const { translatePosition } = this.state;
    const { data } = this.props;
    const isOnStart = translatePosition === 0;
    const isOnEnd = translatePosition === data.length - 1;

    if (Math.abs(xDiff) > Math.abs(yDiff)) {
      if (xDiff > 0 && !isOnStart) {
        this.changeCollection("prev");
      } else if (xDiff < 0 && !isOnEnd) {
        this.changeCollection("next");
      }
    }
    this.x = null;
    this.y = null;
  }

  render() {
    const { data, language } = this.props;
    const { translatePosition, slideGallery, fadeInContent } = this.state;

    const HomeCollectionsContentClasses = classNames(
      "HomeCollections-content",
      fadeInContent && "HomeCollections-contentFaded"
    );

    const isOnStart = translatePosition === 0;
    const isOnEnd = translatePosition === data.length - 1;

    const prevButtonMobileClasses = classNames(
      "ArrowPrevMobile",
      isOnStart && "ArrowPrevMobile--hidden"
    );

    const nextButtonMobileClasses = classNames(
      "ArrowNextMobile",
      isOnEnd && "ArrowNextMobile--hidden"
    );

    const prevButtonClasses = classNames(
      "ArrowPrev",
      isOnStart && "ArrowPrev--hidden"
    );

    const nextButtonClasses = classNames(
      "ArrowNext",
      isOnEnd && "ArrowNext--hidden"
    );

    return (
      <div className="HomeCollections">
        <div className="HomeCollections-text">
          {data[translatePosition].text}
        </div>
        <div className={HomeCollectionsContentClasses}>
          <div className="ArrowsMobile">
            <div className={prevButtonMobileClasses}>
              <button
                className="PrevButton"
                onClick={() => this.changeCollection("prev")}
              >
                <svg
                  className="SvgPrev"
                  width="24"
                  height="24"
                  xmlns="http://www.w3.org/2000/svg"
                  fillRule="evenodd"
                  clipRule="evenodd"
                >
                  <path d="M2.117 12l7.527 6.235-.644.765-9-7.521 9-7.479.645.764-7.529 6.236h21.884v1h-21.883z" />
                </svg>
              </button>
            </div>
            <div className={nextButtonMobileClasses}>
              <button
                className="NextButton"
                onClick={() => this.changeCollection("next")}
              >
                <svg
                  className="SvgNext"
                  width="24"
                  height="24"
                  xmlns="http://www.w3.org/2000/svg"
                  fillRule="evenodd"
                  clipRule="evenodd"
                >
                  <path d="M21.883 12l-7.527 6.235.644.765 9-7.521-9-7.479-.645.764 7.529 6.236h-21.884v1h21.883z" />
                </svg>
              </button>
            </div>
          </div>
          <div className={nextButtonClasses}>
            <button
              className="NextButton"
              onClick={() => this.changeCollection("next")}
            >
              <svg
                className="SvgNext"
                width="24"
                height="24"
                xmlns="http://www.w3.org/2000/svg"
                fillRule="evenodd"
                clipRule="evenodd"
              >
                <path d="M21.883 12l-7.527 6.235.644.765 9-7.521-9-7.479-.645.764 7.529 6.236h-21.884v1h21.883z" />
              </svg>
            </button>
          </div>
          <div className="HomeCollectionContent-Wrapper">
            <h4 className="HomeCollections-title">
              {data[translatePosition].title[language]}
            </h4>
            <div className="HomeCollectionBorder" />
            <p className="HomeCollections-desc">
              {data[translatePosition].description[language]}
            </p>
          </div>
          <div className={prevButtonClasses}>
            <button
              className="PrevButton"
              onClick={() => this.changeCollection("prev")}
            >
              <svg
                className="SvgPrev"
                width="24"
                height="24"
                xmlns="http://www.w3.org/2000/svg"
                fillRule="evenodd"
                clipRule="evenodd"
              >
                <path d="M2.117 12l7.527 6.235-.644.765-9-7.521 9-7.479.645.764-7.529 6.236h21.884v1h-21.883z" />
              </svg>
            </button>
          </div>
        </div>
        <div
          className="HomeCollections-Gallery"
          onTouchStart={event => this.handleTouchStart(event)}
          onTouchEnd={event => this.handleTouchMove(event)}
        >
          <div className="HomeCollections-Gallery-small">
            {data.map((item, index) => {
              const smallImgClasses = classNames(
                "HomeCollection-img-small",
                index === translatePosition &&
                  "HomeCollection-img-small--active",
                slideGallery && "HomeCollection-img-small--slided"
              );
              return (
                <div
                  className={smallImgClasses}
                  key={index}
                  style={{ backgroundImage: `url(${item.photo1})` }}
                />
              );
            })}
          </div>
          <div className="HomeCollections-Gallery-big--wrapper">
            <div
              className="HomeCollections-Gallery-big"
              style={{
                transform: `translateX(-${translatePosition *
                  (100 / data.length)}%)`
              }}
            >
              {data.map((item, index) => {
                return (
                  <div
                    className="HomeCollection-img"
                    key={index}
                    style={{ backgroundImage: `url(${item.photo2})` }}
                  />
                );
              })}
            </div>
          </div>
        </div>
        <div className="HomeCollectionsBorder" />
      </div>
    );
  }
}

function mapStateToProps(state) {
  return {
    language: state.language
  };
}

export default withRouter(connect(mapStateToProps)(HomeCollections));



// WEBPACK FOOTER //
// ./src/components/Home/HomeCollections/index.js